import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RevisionWarningDialogData } from '../../models/dialog.model';

@Component({
  selector: 'app-revision-warning-dialog',
  templateUrl: './revision-warning-dialog.component.html',
  styleUrl: './revision-warning-dialog.component.scss'
})
export class RevisionWarningDialogComponent {
  readonly dialogRef = inject(MatDialogRef<RevisionWarningDialogComponent>);
  readonly data = inject<RevisionWarningDialogData>(MAT_DIALOG_DATA);

  confirm(): void { this.dialogRef.close(true); }
  cancel(): void  { this.dialogRef.close(false); }
}
